import { FormControl, FormHelperText, MenuItem } from '@material-ui/core';
import { observer } from 'mobx-react';
import React from 'react';

import { CancelContractManualRequestDto } from '../../../core/api/dtos';
import { WrappedField } from '../../../core/common/forms';
import { injectTSDI } from '../../../core/common/tsdi';
import { I18n } from '../../../core/i18n';
import { StyledSelect } from '../../../core/styles';
import { StyledBlackInputLabel, StyledBlackLabel } from '../../styles';

interface DateTypeSelectProps {
    cancellationDateTypeField: WrappedField<
        CancelContractManualRequestDto['cancellationDateType']
    >;
    cancellationTypeField: WrappedField<
        CancelContractManualRequestDto['cancellationType']
    >;
}

export const DateTypeSelect = observer((props: DateTypeSelectProps) => {
    const { translate } = injectTSDI(I18n);
    const { cancellationDateTypeField, cancellationTypeField } = props;

    return (
        <FormControl
            fullWidth
            required
            variant="outlined"
            error={Boolean(cancellationDateTypeField.error)}
            disabled={
                cancellationTypeField.value === 'EXTRAORDINARY_CANCELLATION'
            }
        >
            <StyledBlackInputLabel
                id="terminate-contract-by"
                htmlFor="terminate-contract-by-input"
            >
                {translate('public.content.terminate.contract.by')}
            </StyledBlackInputLabel>
            <StyledSelect
                labelId="terminate-contract-by"
                id="contract-termination-date-type"
                inputProps={{ id: 'terminate-contract-by-input' }}
                value={cancellationDateTypeField.value ?? ''}
                label={
                    <StyledBlackLabel>
                        {translate('public.content.terminate.contract.by')}
                    </StyledBlackLabel>
                }
                onChange={(event) =>
                    cancellationDateTypeField.reset(
                        event.target
                            .value as CancelContractManualRequestDto['cancellationDateType']
                    )
                }
                data-role="contract-termination-date-type"
            >
                <MenuItem
                    key="NEXT_POSSIBLE_CANCELLATION_DATE"
                    value="NEXT_POSSIBLE_CANCELLATION_DATE"
                    data-role="contract-termination-date-next-possible"
                >
                    {translate(
                        'public.content.terminate.contract.next.possible.cancellation.date'
                    )}
                </MenuItem>
                <MenuItem
                    key="ABSOLUTE_CANCELLATION_DATE"
                    value="ABSOLUTE_CANCELLATION_DATE"
                    data-role="contract-termination-date-absolute"
                >
                    {translate(
                        'public.content.terminate.contract.absolute.cancellation.date'
                    )}
                </MenuItem>
            </StyledSelect>
            <FormHelperText>
                {cancellationDateTypeField.error
                    ? translate(cancellationDateTypeField.error)
                    : undefined}
            </FormHelperText>
        </FormControl>
    );
});
